<template>

  <div>
    <!--    ok-text="确认并解约"-->
    <!--    @on-ok="ok"-->

    <!--    :class-name="z100000"-->

    <Modal v-model="isShow" :mask-closable="false"
           :loading="loading" width="830"
           class=" long-modal"



    >
      <div slot="footer">
        <!--        <Button type="error" size="large" long :loading="modal_loading" @click="del">Delete</Button>-->
        <Button size="large" @click.stop="cancel">取消</Button>
        <!--        <Button size="large" type="primary"></Button>-->
        <Button size="large" :loading="loadingPre" type="primary" @click.stop="sanyaosu('topdf')">后台解约,预览解约协议</Button>
        <Button size="large" v-if="parentData&& parentData.surType!==9"  type="primary" @click.stop="sanyaosu('forapp')">app解约，提交客户解约</Button>

      </div>
      <h3 slot="header" class="modal-header">解约结算预览</h3>
      <div>


        <div v-if="data">
          <h4>结算明细：</h4>
          <div v-if="data">
            <Row class="row">
              <Col span="4">费用项</Col>
              <Col span="5">应缴费用</Col>
              <Col span="5">已缴费用</Col>
              <Col span="5">应退费用</Col>
              <Col span="5">实退费用</Col>
            </Row>
            <Row class="row" v-for="(item,index) in data.surrenderBanlances"
                 :key="'keyA'+index">
              <Form :model="item" :inline="true" :rules="formRules" :ref="'form1'+index">
                <Col span="4">{{item.expenseItemName}}</Col>
                <Col span="5" class="text-right">
                  {{item.receivableAmount?formatMoney(item.receivableAmount):(item.receivableAmount===0?0:'-')}}
                </Col>
                <Col span="5" class="text-right">
                  {{item.receivedAmount?formatMoney(item.receivedAmount):(item.receivedAmount===0?0:'-')}}
                </Col>
                <Col span="5" class="text-right">
                  {{item.refundAmount?formatMoney(item.refundAmount):(item.refundAmount===0?0:'-')}}
                </Col>
                <Col span="5">
                  <FormItem prop="actRefundAmount" class="notip">
                    <Input class="inputwidth" v-model="item.actRefundAmount"/>
                  </FormItem>
                </Col>
              </Form>
            </Row>
            <Row class="row">
              <Col span="4">合计</Col>
              <Col span="5" class="text-right">{{formatMoney(data.receivableAmount)}}</Col>
              <Col span="5" class="text-right">{{formatMoney(data.receivedAmount)}}</Col>
              <Col span="5" class="text-right">{{formatMoney(data.refundAmount)}}</Col>
              <Col span="5" class="text-right">{{formatMoney(actRefundAmountSum)}}</Col>
            </Row>
          </div>
        </div>

        <div class="notopcheck" style="margin-top: 32px;">
          <h4 class="mb8">未核销账单: <span class="text-red">选中后表示该帐单将和解约结算明细合并收付款，未选中账单将在解约协议审核通过后作废；清退时账单不可选。</span></h4>
          <!--<Table ref="billTable" :data="dataBill" :columns="columnsBill" @on-selection-change="selectChange"></Table>-->
          <div>
            <Row class="row">
              <Col span="5">帐单编号</Col>
              <Col span="5">费用项</Col>
              <Col span="5">账单金额</Col>
              <Col span="5">核销状态</Col>
              <Col span="4"></Col>
            </Row>
            <Row class="row" v-for="item,index in dataBill" :key="'keyTF'+index">
              <Col span="5">{{item.billNumber}}</Col>
              <Col span="5">{{item.finExpenseItemName || '-'}}</Col>
              <Col span="5" style="text-align: right">{{Number(item['feeAmount']/100).toFixed(2)}}</Col>
              <Col span="5">{{item.verificateStatusName}}</Col>
              <Col span="4">
                <Checkbox v-model="item.selected" @on-change="checkNoItem(item)"
                          :disabled="parentData.surType==9"></Checkbox>
              </Col>
            </Row>
            <div v-if="!dataBill.length" class="row ivu-row">暂无数据</div>


          </div>
        </div>
        <!--<div class="bold mb8" style="margin-top: 16px;">未核销账单汇总: {{selectBillTotal}}</div>-->
        <div class="notopcheck mb32">
          <h4 class="mb8">已核销账单 <a @click = "getCancelBillsInfo" href="javascript:void(0)">{{ isShowCancelDataBill ? '收起 ⮝':'展开 ⮟' }}</a></h4>
          <div v-if = "isShowCancelDataBill">
            <Row class="row">
              <Col span="5">帐单编号</Col>
              <Col span="5">费用项</Col>
              <Col span="5">账单金额</Col>
              <Col span="5">核销状态</Col>
            </Row>
            <Row class="row" v-for="item,index in cancelDataBill" :key="'keyTF'+index">
              <Col span="5">{{item.billNumber}}</Col>
              <Col span="5">{{item.finExpenseItemName || '-'}}</Col>
              <Col span="5" style="text-align: right">{{Number(item['feeAmount']/100).toFixed(2)}}</Col>
              <Col span="5">{{item.verificateStatusName}}</Col>
            </Row>
            <div v-if="!cancelDataBill.length" class="row ivu-row">暂无数据</div>
          </div>
        </div>

         <div class="mt36" style="font-weight: bold">
          <div class="inlineblock" style="margin-right: 50px">
            <span>{{actAddSelectBillTotal < 0 ? '乙方付款':'乙方收款'}}</span>:
            <span>{{formatMoney(Math.abs(actAddSelectBillTotal))}}</span>
            <span v-if="actAddSelectBillTotal < 0" style="margin-left:20px" class="red">请提醒用户及时支付结算费用，以免影响自如信用分</span>
          </div>
        </div>
        <div class="mt36 " v-if="Number(actAddSelectBillTotal) > 0">
          <h4>{{actAddSelectBillTotal > 0?'乙方储蓄账户信息':'甲方储蓄账户信息'}}</h4>
          <div v-if="!isLifangtong" style="text-align: center;font-weight: bold;">
            <span>本次退款将打入签约主体的自如账户空间内（三天不满意解约将原路退回）。</span>
          </div>
          <div v-if="isLifangtong && actAddSelectBillTotal > 0 ">
            <Row class="row">
              <Col span="6">开户行名称</Col>
              <Col span="6">银行账号</Col>
              <Col span="6">开户人姓名</Col>
              <Col span="6">证件号</Col>
            </Row>
            <Row class="row">
              <Form :inline="true" :rules="formRules2" ref="countForm" :model="countParams">
                <Col span="6">
                  <FormItem prop="bankNo" class="notip">
                    <Select class="width150" v-model="countParams.bankNo" @on-change="getBankNo">
                      <Option value="">请选择</Option>
                      <Option v-for="({bankName,bankNo},index) in bankList" :value="bankNo" :key="'keyA'+index">{{bankName}}</Option>
                    </Select>
                    <!-- <Input class="width80" v-model="countParams.bankNo"/> -->
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem prop="bankAccount" class="notip">
                    <Input class="width150" v-model="countParams.bankAccount"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem prop="accountName" class="notip">
                    <Input class="width80" :disabled="!!isLifangtong" v-model="countParams.accountName"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem prop="certificatesCode" class="notip">
                    <Input class="width150" :disabled="!!isLifangtong" v-model="countParams.certificatesCode"/>
                  </FormItem>
                </Col>
              </Form>
            </Row>
          </div>
          <!--<Table :columns="columns2" :data="data2"></Table>-->
        </div>


        <div class="mt36">
          <h4>备注</h4>
          <Input type="textarea" v-model="countParams.costRemark"/>
        </div>
        <preview-protocal :n="preN"
                          :contractFid="contractFid"
                          @ok="surrendersubmit"></preview-protocal>
      </div>
    </Modal>
  </div>


</template>
<script>
  import {
    surrenderCalculatePrice, personalsubmit,submitForApp,
    getNoCancelBills,getNoCancelBillsInfo,isEnteredCertificate,updateNoCancelBills,
    getBankNoList,getReceiptType,threeFactorVerify
  } from "api/contractList";
  import {formatMoney} from "utils/format";
  import PreviewProtocal from './PreviewProtocal'
  import {formatDateTime} from "utils/format";

  export default {
    name: "settlePreview",
    components: {
      PreviewProtocal
    },
    props: {
      n: {
        type: Number,
        default: 0
      },
      surrenderIds: {
        type: String,
        default: ''
      },
      parentData: {
        type: Object,
        default: null
      },
      contractFid: {
        type: String,
        default: null
      },

    },
    watch: {
      n() {
        this.dataBill = []

        this.getNoCancelBills()
        this.data = {}

        this.countParams = {
          bankNo: '',
          bankAccount: '',
          accountName: '',
          costRemark: ''
        }
        this.surrenderCalculatePrice();
        this.resetFields()
        this.getBankNoList()
        this.getType();
      }
    },
    data() {
      return {
        projectFid:'',
        surrenderCusCertificatesType:'',
        loadingPre:false,
        preN:0,
        isLifangtong:0,
        columnsBill: [
          {
            title: "帐单编号",
            key: "billNumber",
            align: "center"
          },
          {
            title: "费用项",
            key: "finExpenseItemName",
            align: "center"
          },
          {
            title: "账单金额",
            key: "feeAmount",
            align: "center"

          },
          {
            title: "核销状态",
            key: "verificateStatusName",
            align: "center"
          },
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },

        ],
        bankList:[],
        dataBill: [],
        cancelDataBill: null,
        isShowCancelDataBill: false,
        countParams: {
          bankNo: '',
          bankAccount: '',
          accountName: '',
          costRemark: '',
          certificatesCode:'',
          bankName:'',
        },
        formRules2: {
          bankNo: [
            {required: true, message: '', trigger: 'change', type: 'string'}
          ],
          bankAccount: [
            {required: true, message: '', trigger: 'blur', validator: this.validateNumber}
          ],
          accountName: [
            {required: true, message: '', trigger: 'blur', type: 'string'}
          ],
          certificatesCode: [
            {required: true, message: '', trigger: 'blur', type: 'string'}
          ]
        },
        formRules: {
          actRefundAmount: [
            {required: true, trigger: 'blur', message: ' ', validator: this.validateNumber}
          ]
        },
        data: null,
        z100000: 'z100000',
        loading: true,
        isShow: false,
      }
    },
    computed: {
      selection() {
        return this.dataBill.filter(ele => {
          return ele.selected
        })

      },
      selectBillTotal() {
        let ret = 0
        this.selection.forEach(ele => {
          ret += Number((ele.feeAmount / 100).toFixed(2))
        })
        return Number(ret.toFixed(2))
      },
      actAddSelectBillTotal() {
        return Number((Number(this.actRefundAmountSum) - this.selectBillTotal).toFixed(2))
      },

      actRefundAmountSum() {
        let ret = 0
        this.data && this.data.surrenderBanlances && this.data.surrenderBanlances.forEach(ele => {
          ret += Number(ele.actRefundAmount)
        })
        return ret.toFixed(2)
      },
    },
    methods: {
      getBankNo(data){
        this.bankList.forEach(ele=>{
          if(data===ele.bankNo){
            this.countParams.bankName = ele.bankName
          }
        })
        console.log(this.countParams.bankName)

      },
      getType(){
        getReceiptType({surrenderFid: this.surrenderIds})
        .then(res=>{
          this.isLifangtong = res.data.receiptType
          console.log(this.isLifangtong,'isLit昂')
          this.countParams.accountName = res.data.signName;
          this.projectFid = res.data.projectFid;
          this.surrenderCusCertificatesType = res.data.certificatesType
          this.countParams.certificatesCode = res.data.certificatesCode;
          console.log(res,'xxxx')
        })
      },
      getBankNoList(){
        getBankNoList().then(res=>{
          this.bankList = res.data
          console.log(res,'银行')
        })
      },
      cancel() {
        this.isShow = false
      },

      checkNoItem(item) {
        if (!item.selected) {
          return
        }
        isEnteredCertificate({billNum: item.billNumber}).then(res => {

        }).catch(error => {
          console.log('changing.....')
          item.selected = false
        }).finally(() => {
        })
      },
      getNoCancelBills() {
        if (!this.surrenderIds) {
          return
        }
        const params = {
          surrenderFid: this.surrenderIds,
          isUpdate: '0'
        }
        getNoCancelBills(params).then(res => {
          if (!res.data) {
            return
          }
          this.dataBill = res.data

        }).catch(error => {
          // let res = [{
          //   "billNumber": "string",
          //   "cancelBillFid": "string",
          //   "feeAmount": 0,
          //   "finExpenseItemName": "水费",
          //   "verificateStatus": 0,
          //   "verificateStatusName": "string"
          // }]
          //
          // this.dataBill = res

        })

      },
      getCancelBillsInfo() {
        this.isShowCancelDataBill = ! this.isShowCancelDataBill;
        if(this.cancelDataBill != null) return;
        const params = {
          surrenderFid: this.surrenderIds,
          noCancel: 0
        }
        getNoCancelBillsInfo(params).then(res => {
          if (!res.data) {
            return

          }
          this.cancelDataBill = res.data
        }).catch(error => {
          this.cancelDataBill = []
        })
      },
      formatMoney: formatMoney,
      submitForApp(){
        const params = {
          cancelBillDtos: this.dataBill,
          "surrenderBaseParamDto": {
            "projectFid": this.projectFid,
            "surrenderCusCertificatesCode": this.countParams.certificatesCode,
            "surrenderCusCertificatesType":this.surrenderCusCertificatesType,
            isUpdate: 0,
            "changeRentContractCode": this.parentData.changeContractCode,
            // "surRentPriceDate": this.data.surrenderDate,
            stockRentDate: formatDateTime(this.parentData.stockRentDate, false),
            "stockFid": this.parentData.stockFid,
            "stockStatus": this.parentData.stockStatus,
            "subletCardType": this.parentData.subletCardType,
            "subletCustomerCertNum": this.parentData.subletCustomerCertNum,
            "subletCustomerName": this.parentData.subletCustomerName,
            "subletCustomerPhone": this.parentData.subletCustomerPhone,
            "surType": this.parentData.surType,
            "surrenderFid": this.parentData.surFid,
            surReasonType: this.parentData.surReasonType,
            surReason: this.parentData.surReason,
            "contractFid": this.contractFid,
          },
          "surrenderCostItemParamDtos": this.data.surrenderBanlances,
          "surrenderCostParamDto": {
            "surRentPriceDate": this.data.surrenderDate,
            "accountName": this.countParams.accountName,
            "bankAccount": this.countParams.bankAccount,
            "bankNo": this.countParams.bankNo,
            "bankName": this.countParams.bankName,
            "contractFid": this.contractFid,
            "costAmount": this.actRefundAmountSum,
            "costRemark": this.countParams.costRemark,
            "parentSurrenderFid": this.parentData.parentSurrenderFid,
            "payer": this.actAddSelectBillTotal >= 0 ? 0 : 1,   // 0-出租房 1-承租方
            // "stockStatus": 0,用于企业解约
            "surrenderFid": this.parentData.surFid
          }
        }
        submitForApp(params).then(res => {
          this.$Message.success('已提交，请联系自如客在app完成解约')
          this.$emit('done')
          this.isShow = false
        }).catch(error => {
          this.$Message.info('解约失败')
          this.$emit('done')
          this.isShow = false
        })


      },
      surrendersubmit() {
        const params = {
          cancelBillDtos: this.dataBill,
          "surrenderBaseParamDto": {
            "projectFid": this.projectFid,
            isUpdate: 0,
            "surrenderCusCertificatesCode": this.countParams.certificatesCode,
            "surrenderCusCertificatesType":this.surrenderCusCertificatesType,
            "changeRentContractCode": this.parentData.changeContractCode,
            // "surRentPriceDate": this.data.surrenderDate,
            stockRentDate: formatDateTime(this.parentData.stockRentDate, false),
            "stockFid": this.parentData.stockFid,
            "stockStatus": this.parentData.stockStatus,
            "subletCardType": this.parentData.subletCardType,
            "subletCustomerCertNum": this.parentData.subletCustomerCertNum,
            "subletCustomerName": this.parentData.subletCustomerName,
            "subletCustomerPhone": this.parentData.subletCustomerPhone,
            "surType": this.parentData.surType,
            "surrenderFid": this.parentData.surFid,
            surReasonType: this.parentData.surReasonType,
            surReason: this.parentData.surReason,
            "contractFid": this.contractFid,
          },
          "surrenderCostItemParamDtos": this.data.surrenderBanlances,
          "surrenderCostParamDto": {
            "surRentPriceDate": this.data.surrenderDate,
            "accountName": this.countParams.accountName,
            "bankAccount": this.countParams.bankAccount,
            "bankNo": this.countParams.bankNo,
            "bankName": this.countParams.bankName,
            "contractFid": this.contractFid,
            "costAmount": this.actRefundAmountSum,
            "costRemark": this.countParams.costRemark,
            "parentSurrenderFid": this.parentData.parentSurrenderFid,
            "payer": this.actAddSelectBillTotal >= 0 ? 0 : 1,   // 0-出租房 1-承租方
            // "stockStatus": 0,用于企业解约
            "surrenderFid": this.parentData.surFid
          }
        }
        personalsubmit(params).then(res => {
          this.$Message.info('解约完成，签章后的解约协议，请到解约协议列表打印')
          this.$emit('done')
          this.isShow = false
        }).catch(error => {
          this.$Message.info('解约失败')
          this.$emit('done')
          this.isShow = false
        })

      },

      resetFields() {
        for (const i in this.$refs) {
          if (i === 'countForm') {
            this.$refs[i] && this.$refs[i].resetFields()
          } else {
            this.$refs[i][0] && this.$refs[i][0].resetFields()
          }
        }
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      validateNumber(rule, value, callback) {
        const pattern = /^(-?\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      surrenderCalculatePrice() {
        const params = {
          surrenderIds: this.surrenderIds,
          changeContractCode: this.parentData.changeContractCode
        }
        surrenderCalculatePrice(params).then(res => {
          if(!res.data) {
            this.isShow = true
            return
          }
          console.log(res)
          console.log(res.data.memCode)
          if (res.data.memCode === 1) {
            this.$Message.info(res.data.memMsg)
            return
          }
          if(!res.data.surrenderCostItemList) {
            this.isShow = true
            return
          }
          this.isShow = true
          res.data.surrenderCostItemList && res.data.surrenderCostItemList[0] && (this.data = res.data.surrenderCostItemList[0])
          // res.data && res.data[0] && (this.data = res.data[0])
        }).catch(error => {

        })
      },
      sanyaosu(from){
        let inputValid = true
        for (const i in this.$refs) {
          if (i === 'countForm') {
            this.$refs[i] && this.$refs[i].validate(bool => {
              !bool && (inputValid = false)
            })
          } else {
            this.$refs[i][0] && this.$refs[i][0].validate(bool => {
              !bool && (inputValid = false)
            })
          }
        }
        if (!inputValid) {
          this.$Message.info('请检查录入信息')
          this.changeLoading()
          return
        }
        if(this.actAddSelectBillTotal <= 0){
          this.ok(from)
          return
        }
        threeFactorVerify({
          amount: this.actRefundAmountSum,
          bankNo: this.countParams.bankNo,
          cardNo: this.countParams.bankAccount,
          certNo: this.countParams.certificatesCode,
          idType: this.surrenderCusCertificatesType,
          name: this.countParams.accountName,
          "projectFid": this.projectFid,
          // "telNo": "string"
        })
        .then(res=>{
          console.log(res)
          if(res.data.isPass == 1){
            //通过
            this.ok(from)
          } else if (res.data.isPass == 0 ){
            this.$Modal.confirm({
              title:'异常提醒',
              content:'<p>银行三要素校验失败，请核验银行账号、证件号、开户名是否一致，如继续提交，有可能退款失败，确认继续吗？</p>',
              onOk:()=>{
                // jixu
                this.ok(from)
              }
            })
          }
        })
      },
      ok(from) {
        if(from==='topdf'){
          const params={
            cancelBillDtos: this.dataBill,
            "surrenderBaseParamDto": {
              "projectFid": this.projectFid,
              "surrenderCusCertificatesCode": this.countParams.certificatesCode,
              "surrenderCusCertificatesType": this.surrenderCusCertificatesType,
              isUpdate: 0,
              "changeRentContractCode": this.parentData.changeContractCode,
              stockRentDate: formatDateTime(this.parentData.stockRentDate, false),
              // "surRentPriceDate": this.data.surrenderDate,
              "stockFid": this.parentData.stockFid,
              "stockStatus": this.parentData.stockStatus,
              "subletCardType": this.parentData.subletCardType,
              "subletCustomerCertNum": this.parentData.subletCustomerCertNum,
              "subletCustomerName": this.parentData.subletCustomerName,
              "subletCustomerPhone": this.parentData.subletCustomerPhone,
              "surType": this.parentData.surType,
              "surrenderFid": this.parentData.surFid,
              surReasonType: this.parentData.surReasonType,
              surReason: this.parentData.surReason,
              "contractFid": this.contractFid,
            },
            "surrenderCostItemParamDtos": this.data.surrenderBanlances,
            "surrenderCostParamDto": {
              "surRentPriceDate": this.data.surrenderDate,
              "accountName": this.countParams.accountName,
              "bankAccount": this.countParams.bankAccount,
              "bankNo": this.countParams.bankNo,
              "bankName": this.countParams.bankName,
              "certificatesCode": this.countParams.certificatesCode,
              "contractFid": this.contractFid,
              "costAmount": this.actRefundAmountSum,
              "costRemark": this.countParams.costRemark,
              "parentSurrenderFid": this.parentData.parentSurrenderFid,
              "payer": this.actAddSelectBillTotal >= 0 ? 0 : 1,   // 0-出租房 1-承租方
              // "stockStatus": 0,用于企业解约
              "surrenderFid": this.parentData.surFid
            }

          }
          this.loadingPre=true
          updateNoCancelBills(params).then(res=>{
            this.preN++
          }).catch(error=>{


          }).finally(()=>{
            this.loadingPre=false
          })
        }
        if(from==='forapp'){
          this.submitForApp()
        }


      },
    }

  }
</script>

<style scoped>
  .width150{
    width: 150px;
  }
  .width80 {
    width: 80%;
  }

  .inputwidth {
    width: 80px;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

  .inlineblock {
    display: inline-block;
  }

  h4 {
    margin: 0 0 10px 0;
  }
  .red{
    color: red;
  }

</style>
